import React from 'react';
import {Box, Button, IconButton, Stack, Tooltip} from '@mui/material';
import TableRowsIcon from '@mui/icons-material/TableRows';
import GridViewIcon from '@mui/icons-material/GridView';
import FileListGrid from '../components/FileListGrid';
import FileGrid from '../components/FileGrid';
import Breadcrumbs from '../components/Breadcrumbs';
import {useFileContext} from '../context/FileContext';
import DownloadIcon from '@mui/icons-material/Download';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolderOutlined';
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverOutlined';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import {SortButton} from 'components/SortButton';
import UploadFiles from 'components/UploadFiles';
// import TileSizeControl from 'components/TileSizeControl';
import {Dropzone} from 'components/inputs/Dropzone';
import ConfirmationWrapper from 'components/buttons/ConfirmationWrapper';
import {useTranslation} from 'react-i18next';
import {FileMenuContextProvider} from 'components/context-menu/fileMenuContext';
import {ContextMenu} from 'components/context-menu/ContextMenu';
import {ResponsiveActionButton} from 'components/buttons/ResponsiveActionButton';

const Home: React.FC = () => {
   const {t} = useTranslation();
   const {
      viewMode,
      setViewMode,
      selectedFiles,
      downloadEncrypted,
      removeSelected,
      create: {createNewFolder},
      move: {moveSelected},
   } = useFileContext();

   const handleDownload = () => {
      // if (selectedFile.length === 1) {
      const selectedFile = selectedFiles[0];

      if (selectedFile && selectedFile.type === 'file') {
         downloadEncrypted(selectedFile.path);
         // const fileUrl = `/api/download?path=${selectedFile.path}`;
         // window.open(fileUrl, '_blank'); // Open file in new tab or download
      }
      // }
   };

   return (
      <Box>
         <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Stack direction="row" spacing={2} sx={{flex: 1, justifyContent: 'center'}}>
               <UploadFiles />

               <ResponsiveActionButton
                  label={t('Download')}
                  icon={<DownloadIcon />}
                  onClick={handleDownload}
                  color="primary"
                  disabled={selectedFiles.length !== 1 || selectedFiles[0].type !== 'file'}
                  tooltip={
                     selectedFiles.length > 1
                        ? t('Multiple downloads are not available.')
                        : t('Download file')
                  }
               />

               <ResponsiveActionButton
                  label={t('Create')}
                  icon={<CreateNewFolderIcon />}
                  onClick={createNewFolder}
                  color="secondary"
                  tooltip={t('Create folder')}
               />
               <ResponsiveActionButton
                  label={t('Move')}
                  icon={<OpenWithIcon />}
                  onClick={moveSelected}
                  color="info"
                  disabled={selectedFiles.length !== 1 || selectedFiles[0].type !== 'file'}
                  tooltip={
                     selectedFiles.length > 1
                        ? t('Multiple moves are not available.')
                        : t('Move Item')
                  }
               />

               <ConfirmationWrapper
                  content={t(
                     `Are you sure you want to permanently delete these ${selectedFiles.length} file(s)?`
                  )}
                  onOk={removeSelected}
                  disabled={!selectedFiles.length}
               >
                  <ResponsiveActionButton
                     label={t('Delete Selected')}
                     icon={<DeleteForeverIcon />}
                     color="warning"
                     disabled={!selectedFiles.length}
                     tooltip={t('Delete selected')}
                  />
               </ConfirmationWrapper>
            </Stack>

            {/* {viewMode === 'grid' && <TileSizeControl />} */}
            <IconButton onClick={() => setViewMode(viewMode === 'table' ? 'grid' : 'table')}>
               {viewMode === 'table' ? <GridViewIcon /> : <TableRowsIcon />}
            </IconButton>
            <SortButton />
         </Box>
         <Box sx={{margin: '0 0 1rem 1rem'}}>
            <Breadcrumbs />
         </Box>
         <FileMenuContextProvider>
            {viewMode === 'table' ? (
               // <FileList files={files} onFileClick={handleFileClick} />
               <FileListGrid />
            ) : (
               <FileGrid />
            )}
            <ContextMenu />
         </FileMenuContextProvider>
         <Dropzone />
      </Box>
   );
};

export default Home;
